export const emptyResults = (indexType) => {
    return ({query}, {html}) => {
        return html`Sorry, we can't find any matching ${indexType} for '${query}'.`;
    };
};
